import { Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";
import { useEffect } from "react";
import { Menu } from "lucide-react";
import myAppConfig from "./config";
import { SidebarProvider, SidebarInset, useSidebar } from "./components/ui/sidebar";
import { AppSidebar } from "./components/nav_bar/app-sidebar";

function FloatingTrigger() {
  const { toggleSidebar } = useSidebar();
  return (
    <button
      onClick={toggleSidebar}
      className="md:hidden fixed top-6 left-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-card border border-border/50 shadow-lg backdrop-blur-sm text-foreground"
    >
      <Menu className="h-5 w-5" />
    </button>
  );
}

function App() {
  useEffect(() => {
    const msg = typeof window !== 'undefined' ? sessionStorage.getItem("auth_toast_msg") : null;
    if (msg) {
      setTimeout(() => toast.error(msg), 0);
      try { sessionStorage.removeItem("auth_toast_msg"); } catch (_) {}
    }
  }, []);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <FloatingTrigger />
        <Outlet />
      </SidebarInset>
      <Toaster />
    </SidebarProvider>
  );
}

export default App;